import React, { Component } from 'react';
import './MessageInput.css';
import { TEXT } from '../../../../../../../content';

class MessageInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focus: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  // -----------------------------------------------------------------------------------
  // Handlers
  // -----------------------------------------------------------------------------------

  handleChange(e) {
    const { messageUpdate } = this.props;
    messageUpdate(e.target.value);
  }

  handleSend() {
    const { messageSend, message } = this.props;
    if (message.length > 0) {
      messageSend();
    }
  }

  handleFocus() {
    const { videoPause } = this.props;
    videoPause();
    this.setState({
      focus: true,
    });
  }

  handleBlur() {
    this.setState({
      focus: false,
    });
  }

  // -----------------------------------------------------------------------------------
  // Render
  // -----------------------------------------------------------------------------------

  render() {
    const { focus } = this.state;
    const { message } = this.props;
    return (
      <div>
        <div className="mi-title">
          <span>{TEXT.PERSON}</span>
          {` ${TEXT.OR} `}
          <span>{TEXT.PLACE}</span>
          <div>{TEXT.ON_VIDEO}</div>
        </div>
        <textarea
          className="mi-input"
          maxLength="4000"
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          value={message}
        />
        <button
          className={`mi-btn ${focus || message.length > 0 ? '' : 'hide'}`}
          disabled={message.length === 0}
          type="button"
          onClick={this.handleSend}
        >
          {TEXT.BTN_SEND}
        </button>
      </div>
    );
  }
}

export default MessageInput;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/MessageBlock/MessageInput/MessageInput.js